export default "__VITE_ASSET__BddUem7R__"